/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UploadsControllerSignQueryResponse } from "../../models/uploadsController/UploadsControllerSign";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { uploadsControllerSign } from "../../clients/uploadsService/uploadsControllerSign";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const uploadsControllerSignQueryKey = () => [{
  url: '/api/v1/uploads/signature'
}] as const;
export type UploadsControllerSignQueryKey = ReturnType<typeof uploadsControllerSignQueryKey>;
export function uploadsControllerSignQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = uploadsControllerSignQueryKey();
  return queryOptions<UploadsControllerSignQueryResponse, ResponseErrorConfig<Error>, UploadsControllerSignQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return uploadsControllerSign(config);
    }
  });
}

/**
 * @summary Generate Transloadit signature for Uppy assemblies
 * {@link /api/v1/uploads/signature}
 */
export function useUploadsControllerSign<TData = UploadsControllerSignQueryResponse, TQueryData = UploadsControllerSignQueryResponse, TQueryKey extends QueryKey = UploadsControllerSignQueryKey>(options: {
  query?: Partial<QueryObserverOptions<UploadsControllerSignQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? uploadsControllerSignQueryKey();
  const query = useQuery({
    ...uploadsControllerSignQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}